import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import { cn } from '@/lib/utils';

interface MarkdownTextProps {
  children: string;
  className?: string;
}

export function MarkdownText({ children, className }: MarkdownTextProps) {
  // react-markdown 10 quitó la prop `className`: en dev tira excepción y en el
  // build de prod la ignora en silencio (los estilos prose no se aplicaban).
  // El wrapper es la migración oficial.
  return (
    <div
      className={cn(
        'prose prose-sm dark:prose-invert max-w-none leading-relaxed',
        // Más aire entre párrafos/bloques (los bloques venían muy compactos)
        'prose-p:my-2.5 prose-headings:mt-3 prose-headings:mb-1.5 prose-ul:my-2 prose-ol:my-2 prose-li:my-1',
        className,
      )}
    >
      <ReactMarkdown remarkPlugins={[remarkGfm]}>{children}</ReactMarkdown>
    </div>
  );
}
